import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { Image } from 'components';
import { MoreHoriz } from '@mui/icons-material';

const TopicItem = ({
	topic,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(topic, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(topic, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(topic.id);

	return (
		<TableRow
			hover
			onClick={() => {
				handleClick(topic);
				handleClose();
			}}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(topic)}
						name="topic"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={topic.thumbnail_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{topic.title}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{topic.order}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default TopicItem;
